<template>
  <label class="briefField">
    <span class="briefLabel">{{ BRIEF_LABEL }}</span>
    <textarea
      class="briefInput"
      :value="modelValue"
      :rows="rows ?? 6"
      :disabled="disabled"
      placeholder="e.g. VPs of Sales at US software companies with 200 to 2000 people that just raised a Series B, because they are hiring reps and need pipeline fast."
      @input="emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
    />
  </label>
</template>

<script setup lang="ts">
import { BRIEF_LABEL } from '../../composables/useStrategyPlay'

defineProps<{ modelValue: string; rows?: number; disabled?: boolean }>()
const emit = defineEmits<{ (e: 'update:modelValue', value: string): void }>()
</script>

<style scoped>
.briefField {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}
.briefLabel {
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  font-weight: var(--fw-semibold);
  color: var(--color-text-primary);
}
.briefInput {
  width: 100%;
  resize: vertical;
  padding: var(--space-3);
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-md);
  background: var(--color-bg-app);
  color: var(--color-text-primary);
  font-family: var(--font-sans);
  font-size: var(--fs-sm);
  line-height: 1.5;
}
.briefInput:focus {
  outline: none;
  border-color: var(--color-accent);
}
</style>
